import { toast } from "sonner";
import { http } from "./apparelHttp";

let loginUrl: any = process.env.REACT_APP_APPAREL_LOGIN_URL;
let url: any = process.env.REACT_APP_APPAREL_URL;
// let loginUrl: any = "http://localhost:8092/api/login"
// let url: any = "http://localhost:8092/api/apparel"

let apparelAxiosApi = {
  getList(payload: any) {
    return Method.dataPost(payload, url)
  },
  createCustomer(payload: any) {
    return Method.dataPost(payload, url)
  },
  mergeCustomer(payload: any) {
    return Method.dataPost(payload, url)
  },
  setCustomerCreditLimit(payload: any) {
    return Method.dataPost(payload, url)
  },
  addCustomerCreditOpeningBalance(payload: any) {
    return Method.dataPost(payload, url)
  },
  recordCustomerCreditSettlement(payload: any) {
    return Method.dataPost(payload, url)
  },
  getCustomerCreditLedger(payload: any) {
    return Method.dataPost(payload, url)
  },
  updateProductItemColorOrSize(payload: any) {
    return Method.dataPost(payload, url)
  },
  addProduct(payload: any) {
    return Method.dataPost(payload, url)
  },
  categoryAndSubCategoryList(payload: any) {
    return Method.dataPost(payload, url)
  },
  updateProductStatus(payload: any) {
    return Method.dataPost(payload, url)
  },
  updateStickeringStatus(payload: any) {
    return Method.dataPost(payload, url)
  },
  getProductList(payload: any) {
    return Method.dataPost(payload, url)
  },
  getCustomerList(payload: any) {
    return Method.dataPost(payload, url)
  },
  getReferenceData(payload: any) {
    return Method?.dataPost(payload, url)
  },
  getProductItems(payload: any) {
    return Method?.dataPost(payload, url)
  },
  createBill(payload: any) {
    return Method?.dataPost(payload, url)
  },
  createBill_V2(payload: any) {
    return Method?.dataPost(payload, url)
  },
  getBillingList(paylaod: any) {
    return Method?.dataPost(paylaod, url)
  },
  apparelLogin(payload: any) {
    return Method?.dataPost(payload, loginUrl)
  },
  sendLoginOtp(payload: any) {
    return Method?.dataPost(payload, loginUrl)
  },
  verifyLoginOtp(payload: any) {
    return Method?.dataPost(payload, loginUrl)
  },
  getCustomerHistory(payload: any) {
    return Method?.dataPost(payload, url)
  },
  getEmployeeSalesHistory(payload: any) {
    return Method?.dataPost(payload, url)
  },
  getProductHistory(payload: any) {
    return Method?.dataPost(payload, url)
  },
  getInvoiceDetails(payload: any) {
    return Method?.dataPost(payload, url)
  },
  updateMultipleInventory(payload: any) {
    return Method?.dataPost(payload, url)
  },
  getMultipleInventoryCounts(payload: any) {
    return Method?.dataPost(payload, url)
  },
  getMultipleInventorySoldList(payload: any) {
    return Method?.dataPost(payload, url)
  },
  getMultipleInventoryDamagedList(payload: any) {
    return Method?.dataPost(payload, url)
  },
  createOrUpdateCycleCount(payload: any) {
    return Method?.dataPost(payload, url)
  },
  getCycleCountList(payload: any) {
    return Method?.dataPost(payload, url)
  },
  cycleCountListSearch(payload: any) {
    return Method?.dataPost(payload, url)
  },
  getMultipleSubCategoryList(payload: any) {
    return Method?.dataPost(payload, url)
  },
  getProductListCategory(payload: any) {
    return Method?.dataPost(payload, url)
  },
  getupdateCycleCountProduct(payload: any) {
    return Method?.dataPost(payload, url)
  },
  updateCycleCountList(paylaod: any) {
    return Method?.dataPost(paylaod, url)
  },
  getMultipleScrapList(paylaod: any) {
    return Method?.dataPost(paylaod, url)
  },
  getStockHistory(payload: any) {
    return Method?.dataPost(payload, url)
  },
  getStockMovementHistory(payload: any) {
    return Method?.dataPost(payload, url)
  },
  adminAdjustStock(payload: any) {
    return Method?.dataPost(payload, url)
  },
  getComboComponentOptions(payload: any) {
    return Method?.dataPost(payload, url)
  },
  getComboItems(payload: any) {
    return Method?.dataPost(payload, url)
  },
  getCycleCountReportList(paylaod: any) {
    return Method?.dataPost(paylaod, url)
  },
  getAttendanceList(payload: any) {
    return Method?.dataPost(payload, url)
  },
  getEmployeeAttendanceCalendar(payload: any) {
    return Method?.dataPost(payload, url)
  },
  getEmployeeAttendanceSummary(payload: any) {
    return Method?.dataPost(payload, url)
  },
  getAttendanceRecordById(payload: any) {
    return Method?.dataPost(payload, url)
  },
  markAttendance(payload: any) {
    return Method?.dataPost(payload, url)
  },
  getReportList(paylaod: any) {
    return Method?.dataPost(paylaod, url)
  },
  getVendorList(payload: any) {
    return Method?.dataPost(payload, url)
  },
  createOrUpdateVendor(payload: any) {
    return Method?.dataPost(payload, url)
  },
  getVendorEmailValidation(payload: any) {
    return Method?.dataPost(payload, url)
  },
  getVendorDropDownListApi(payload: any) {
    return Method?.dataPost(payload, url)
  },
  getVendorPurchaseList(payload: any) {
    return Method?.dataPost(payload, url)
  },
  createOrUpdateVendorPurchase(payload: any) {
    return Method?.dataPost(payload, url)
  },
  getRentalList(payload: any) {
    return Method?.dataPost(payload, url)
  },
  createOrUpdateRental(payload: any) {
    return Method?.dataPost(payload, url)
  },
  getVendorPurchaseHistory(payload: any) {
    return Method?.dataPost(payload, url)
  },
  getVendorDebtLedger(payload: any) {
    return Method?.dataPost(payload, url)
  },
  createVendorDebtEntry(payload: any) {
    return Method?.dataPost(payload, url)
  },
  getMrpListApi(payload: any) {
    return Method?.dataPost(payload, url)
  },
  getEmployeeList(payload: any) {
    return Method?.dataPost(payload, url)
  },
  createOrUpdateEmployee(payload: any) {
    return Method?.dataPost(payload, url)
  },
  getEmployeeDropDownListApi(payload: any) {
    return Method?.dataPost(payload, url)
  },
  createOrUpdateProcurementApi(payload: any) {
    return Method?.dataPost(payload, url)
  },
  getProcurementApi(payload: any) {
    return Method?.dataPost(payload, url)
  },
  getProcurementExportList(payload: any) {
    return Method?.dataPost(payload, url)
  },
  getAuditLogList(payload: any) {
    return Method?.dataPost(payload, url)
  },
  createOrUpdateAttachmentAxios(payload: any) {
    return Method?.dataPost(payload, url)
  },
  getAttachmentAxios(payload: any) {
    return Method?.dataPost(payload, url)
  },
  getVendorBillAttachmentAxios(payload: any) {
    return Method?.dataPost(payload, url)
  },
  getVendorDebtAttachmentAxios(payload: any) {
    return Method?.dataPost(payload, url)
  },
  getSalesReturnApi(payload: any) {
    return Method?.dataPost(payload, url)
  },
  createOrUpdateSalesReturnApi(payload: any) {
    return Method?.dataPost(payload, url)
  },
  getSalesReturnBasedOnProductIdApi(payload: any) {
    return Method?.dataPost(payload, url)
  },
  getSalesReturnBillDetailsApi(payload: any) {
    return Method?.dataPost(payload, url)
  },
  addCategoryAxios(payload: any) {
    return Method?.dataPost(payload, url)
  },
  createOrUpdateBannerAxios(payload: any) {
    return Method?.dataPost(payload, url)
  },
  getMetBannerApi(payload: any) {
    return Method?.dataPost(payload, url)
  },
  getBannerAttachmentApi(payload: any) {
    return Method?.dataPost(payload, url)
  },
  addSubCategoryAxios(payload: any) {
    return Method?.dataPost(payload, url)
  },
  getHotNewTopPickAxios(payload: any) {
    return Method?.dataPost(payload, url)
  },
  createOrUpdateHotNewTopAxios(payload: any) {
    return Method?.dataPost(payload, url)
  },
  getOnlineOrderAxios(payload: any) {
    return Method?.dataPost(payload, url)
  },
  updateOrderAxios(paylaod: any) {
    return Method?.dataPost(paylaod, url)
  },
  getCoreCategoryAxios(paylaod: any) {
    return Method?.dataPost(paylaod, url)
  },
  getDashboardData(paylaod: any) {
    return Method?.dataPost(paylaod, url)
  }
}

const Method = {
  async dataPost(body: any, url: any) {
    return await new Promise((resolve, reject) => {
      http.post(url, {
        query: body,
      }, {
        headers: {
          'Content-Type': 'application/json',
          // 'access-control-allow-origin': '*',
          'Authorization': localStorage.authToken
        }
      }).then((result) => {
        if (result.status === 200) {
          return resolve({
            status: 1,
            result: result,
          });
        } else if (result.status == 212) {
          return resolve({
            status: 4,
            result: result,
          });
        } else {
          if (result) {
            return reject({
              status: 3,
              error: "Something went wrong.",
            });
          } else {
            return reject({
              status: 4,
              error: "Something went wrong.",
            });
          }
        }
      }).catch((err) => {
        if (err.response) {
          if (
            err.response.status !== null &&
            err.response.status !== undefined
          ) {
            if (err.response.status == 401) {
              let unauthorizedStatus = err.response.status;
              if (unauthorizedStatus == 401) {
                toast.error("401 unauthorized");
              }
            } else {
              return reject({
                status: 5,
                error: err,
              });
            }
          }
        } else {
          return reject({
            status: 5,
            error: err,
          });
        }
      });
    });
  }
}

export { apparelAxiosApi };